import { DEFAULT_PAGE_SIZE } from "constant/app";
import * as QS from "util/query-string";

/*
 * Add query string pagination to your component.
 *
 * NOTE: This exploits history reference to location. Otherwise, you must
 * pass in location to each function call.
 */
class Paginator {
  constructor(history) {
    this._lastPageSize = null;
    this._history = history;

    this.initPaginationQueryParams = this.initPaginationQueryParams.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
  }

  get lastPageSize() {
    return this._lastPageSize;
  }

  set lastPageSize(pageSize) {
    this._lastPageSize = parseInt(pageSize, 10);
  }

  _getLocationParams() {
    return QS.parse(this._history.location.search);
  }

  getTablePageOptions() {
    const params = this._getLocationParams();
    const options = {};

    if (params.page_size) {
      options.sizePerPage = parseInt(params.page_size, 10);
    }

    if (params.page) {
      options.page = parseInt(params.page, 10);
    }

    return options;
  }

  /*
   * If required query params are missing, set them. And init any
   * necessary component state.
   */
  initPaginationQueryParams() {
    const { pathname } = this._history.location;
    const params = this._getLocationParams();

    let redirect = false;
    if (!params.page) {
      params.page = 1;
      redirect = true;
    }

    if (!params.page_size) {
      params.page_size = DEFAULT_PAGE_SIZE;
      redirect = true;
    }

    this.lastPageSize = params.page_size;

    if (redirect) {
      this._history.push({ pathname, search: QS.stringify(params) });
    }
  }

  onPageChange(page, sizePerPage) {
    const { pathname } = this._history.location;
    const params = this._getLocationParams();

    if (sizePerPage !== this.lastPageSize) {
      // When page size changes, reset page to 1.
      this.lastPageSize = sizePerPage;
      page = 1;
    }

    params.page = page;
    params.page_size = sizePerPage;

    this._history.push({ pathname, search: QS.stringify(params) });
  }
}

export { Paginator };
